import {
    cleanItem,
    itemEditor,
    ui
} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {summaryLines} from "../common/summary-lines-expo";

import {FutureFulfillment}      from "./future-fulfillment";
import {FutureFulfillmentLogic} from "./future-fulfillment-logic";

export const futureFulfillmentModules = ({item}) => [
    {
        name: "futureFulfillment1",
        load: ({}, next) => FutureFulfillmentLogic({item, next}),
        expo: [cleanItem],
    },
    {
        name: "futureFulfillment2",
        load: ({futureFulfillment1, method}, next) => method !== "download" ? (
            futureFulfillment1.next({next})
        ) : (
            next(null)
        ),
        expo: [itemEditor, summaryLines],
        requires: ["futureFulfillment1", "method"],
    },
    {
        load: ({futureFulfillment2}, next) => next({
            ui: futureFulfillment2?.ui && (
                ({showErrors}) => FutureFulfillment({
                    showErrors,
                    ui: futureFulfillment2.ui,
                })
            )
        }),
        expo: [ui("futureFulfillment")],
        requires: ["futureFulfillment2"],
    },
];
